import initVueApp from "@/core.js";
const component = require(`../views/ReturnsPortal.vue`).default;
initVueApp(component);
